import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
} from '@mui/material'
import dayjs from 'dayjs'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { ALL_GENDERS, EVENT_TYPES_ARRAY, MOMENT_FORMATS } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import DetailComponent from 'src/supportPortal/components/common/bookedEventInfo/components/DetailComponent'
import { formatEventTimeRange, formatRescheduleTimeChange } from 'src/supportPortal/components/common/bookedEventInfo/components/utils'
import { postSPData, postSPDataWithParams } from 'src/supportPortal/services/services'

export default function ReschedulePopup({
  bookedEventInfo,
  newStartTime,
  afterActionFunction,
  closeDialog,
  allSidebarItems,
}) {
  const currentRoom = allSidebarItems?.find(
    (item) => item?.clinicId === bookedEventInfo?.clinicLocationId,
  )

  const clinicBrand = {
    id: currentRoom?.clinicBrandId,
    title: currentRoom?.clinicBrandName,
  }

  console.log({ bookedEventInfo })

  const [sendCommunicationToClient, setSendCommunicationToClient] = useState(true)
  const [sendCommunicationToMentor, setSendCommunicationToMentor] = useState(true)
  const [rescheduling, setRescheduling] = useState(false)

  async function rescheduleSession() {
    setRescheduling(true)
    const response = await postSPDataWithParams(
      '/api/secure/cc/support/events/reschedule',
      { newStartTime: dayjs.utc(newStartTime).format('YYYY-MM-DD HH:mm:ss') },
      {
        bookedEventId: bookedEventInfo?.id,
        sendCommunicationToClient: sendCommunicationToClient,
        sendCommunicationToMentor: sendCommunicationToMentor,
      },
    )
    setRescheduling(false)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      toast.success('Booking Rescheduled')
      afterActionFunction && afterActionFunction(response.data.data?.['booked-event-info'])
    } else {
      if (response?.data?.message) {
        toast.error(`Failed: ${response?.data?.message}`)
      } else {
        toast.error('Failed: Something went wrong')
      }
    }
  }
  const currentEventType = EVENT_TYPES_ARRAY?.find((event) => {
    return event?.id === bookedEventInfo?.eventType
  })

  return (
    <>
      <DialogTitle>
        <div className="w-100 fs-6 d-flex justify-content-between align-items-center">
          <span>Reschedule {formatRescheduleTimeChange(bookedEventInfo, newStartTime)}</span>
          <div className="d-flex align-items-center gap-1">
            <span>{currentEventType?.title}</span>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-center gap-2">
          <span>{bookedEventInfo?.patientInfo?.patientNumber}</span>
          <strong>{bookedEventInfo?.patientInfo?.name}</strong>
          <span>
            ({getAgeFromDobWithTime(bookedEventInfo?.patientInfo?.dateOfBirth)}/
            {ALL_GENDERS?.find((gndr) => gndr?.id === bookedEventInfo?.patientInfo?.gender)?.title})
          </span>
        </div>
      </DialogTitle>
      <DialogContent>
        {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span>
            <strong>Initial Start Time</strong>:{' '}
            {dayjs
              .utc(bookedEventInfo?.startTime)
              .local()
              .format(MOMENT_FORMATS.completeTimeDetails)}
          </span>
          <span>
            <strong>New Start Time</strong>:{' '}
            {dayjs.utc(newStartTime).local().format(MOMENT_FORMATS.completeTimeDetails)}
          </span>
          <span>
            <strong>Event Duration</strong>:{' '}
            {Math.floor(bookedEventInfo?.eventDuration / 60)} minutes
          </span>
          <span>
            <strong>Clinic</strong>: {currentRoom?.clinicBrandName} |{' '}
            {currentRoom?.clinicLocationName}
          </span>
          <span>
            <strong>Mentor</strong>: {bookedEventInfo?.mentorName}
          </span>
          <span>
            <strong>Patient</strong>: {bookedEventInfo?.patientInfo?.name}
          </span>
        </Box> */}
        <DetailComponent bookedEventInfo={bookedEventInfo} clinicBrand={clinicBrand} hideButtons hideSessionStatus />
        <FormControlLabel
          labelPlacement="end"
          control={
            <Checkbox
              id="sendCommunicationToClient"
              checked={sendCommunicationToClient}
              onChange={(e) => {
                setSendCommunicationToClient(e.target.checked)
              }}
            />
          }
          label="Send Communication to Client"
        />
        <FormControlLabel
          labelPlacement="end"
          control={
            <Checkbox
              id="sendCommunicationToMentor"
              checked={sendCommunicationToMentor}
              onChange={(e) => {
                setSendCommunicationToMentor(e.target.checked)
              }}
            />
          }
          label="Send Communication to Mentor"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={rescheduleSession}
          disabled={rescheduling}
        >
          Reschedule
        </Button>
      </DialogActions>
    </>
  )
}
